class AddCartButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      let formData = {
       'items': [
          {
            'id': parseInt($("#productoComplementario2").attr("data-id-variant")),
            'quantity': 1,
            "properties" : {
               "id_product_complementario": parseInt($("#productoComplementario2").attr("data-id-variant")),
               "precio_product_complementario": parseInt($("#productoComplementario2").attr("data-porcentaje-complementario")),
               "name_promo_complementario": $("#productoComplementario2").attr("data-title-promo"),
               "id_product_main": parseInt($("#productoComplementario1").attr("data-id-variant")),
               "porcentaje": $("#productoComplementario2").attr("data-porcentaje"),
               "type_discount": $("#productoComplementario2").attr("data-type-discount")
            }
          },
          {
           'id': parseInt($("#productoComplementario1").attr("data-id-variant")),
            'quantity': 1
          }
          
          
         ]
      };
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .then(response => {
          location.href = "/cart";
          return response.json();
      })
      .catch((error) => {
          console.error('Error:', error);
       });
    });
  }
}

customElements.define('add-cart', AddCartButton);